import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { LicenseAssignment } from '../Enums/LicenseAssignment.enum';

export class UserAssignedLicense<T extends EMode = EMode.entity> {
  /** Alias: assigned */
  assigned?: boolean;
  /** Alias: license */
  license?: LicenseAssignment;

  __typename?: string;
}

const fields: FieldDefinitions<UserAssignedLicense> = {
  assigned: {
    alias: 'assigned',
  },
  license: {
    alias: 'license',
  },
  __typename: {
    alias: '__typename',
  },
};

export const userAssignedLicenseEntityDefinition: EntitiyDefinition<UserAssignedLicense> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'UserAssignedLicense',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
